export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7279.c4b11339.jpg";